import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

import LunaSearchLogo from '../assets/appbar_icon.png'; // Your logo

const Footer = ({ backgroundColor = '#000' }) => {
  return (
    <footer className="footer" style={{ backgroundColor }}>
      <div className="footer-container">
        {/* Logo + Brand */}
        <div className="footer-section footer-logo-section">
          <img src={LunaSearchLogo} alt="LunaSearch Logo" className="footer-logo" />
          <span className="footer-brand">LunaSearch</span>
        </div>

        {/* Navigation Links */}
        <div className="footer-section">
          <h4 className="footer-heading">Navigation</h4>
          <nav className="footer-links">
            <Link to="/" className="footer-link">Home</Link>
            <Link to="/guide" className="footer-link">Guide</Link>
            <Link to="/purchase" className="footer-link">Purchase</Link>
            <Link to="/affiliate" className="footer-link">Affiliate</Link>
            {/* <Link to="/docs" className="footer-link">Docs</Link> */}
          </nav>
        </div>

        {/* Legal Links */}
        <div className="footer-section">
          <h4 className="footer-heading">Legal</h4>
          <nav className="footer-links">
            <Link to="/privacy" className="footer-link">Privacy Policy</Link>
            <Link to="/terms" className="footer-link">Terms of Use</Link>
          </nav>
        </div>

        {/* Social Links */}
        <div className="footer-section">
          <h4 className="footer-heading">Connect</h4>
          <div className="footer-links">
            {/* <a href="https://twitter.com/lunasearch" target="_blank" rel="noopener noreferrer" className="footer-link">Twitter</a> */}
            <a href="https://telegram.me/lunasearch" target="_blank" rel="noopener noreferrer" className="footer-link">Telegram</a>
            {/* <a href="https://github.com/lunasearch" target="_blank" rel="noopener noreferrer" className="footer-link">GitHub</a> */}
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        &copy; {new Date().getFullYear()} LunaSearch. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
